import type { ReactNode, Ref } from "react";
import type { LabelProps as AriaLabelProps } from "react-aria-components";
import { FieldLabel } from "@/components/base/input/field-label";

interface LabelProps extends AriaLabelProps {
	children: ReactNode;
	isRequired?: boolean;
	/** When true, the required asterisk uses the filled (brand) color. */
	isFilled?: boolean;
	tooltip?: string;
	tooltipDescription?: string;
	ref?: Ref<HTMLLabelElement>;
}

export const Label = ({
	isRequired,
	isFilled = false,
	tooltip,
	tooltipDescription,
	className,
	children,
	...props
}: LabelProps) => {
	return (
		<FieldLabel
			isRequired={isRequired}
			isFilled={isFilled}
			tooltip={tooltip}
			tooltipDescription={tooltipDescription}
			className={className}
			{...props}
		>
			{children}
		</FieldLabel>
	);
};

Label.displayName = "Label";
